import { Router } from "@frui.ts/screens";
import { computed } from "mobx";
import { Modules } from "config";
import LocalizationService from "services/localizationService";
import type CountrySelectViewModel from "../../../../countrySelectViewModel";
import TransferRefundsViewModel from "../transferRefundsViewModel";
import EventBus, { foreignTransferRefundUpdated } from "services/eventBus";
import { bound } from "@frui.ts/helpers/dist";
import RefundType from "entities/refundType";
import ForeignRefundDetailViewModel from "./foreignRefundDetailViewModel";
import RefundRepository from "repositories/refundRepository";
import OptionsService from "services/optionsService";
import RefundsApprovalService from "services/refundsApprovalService";
import TransferPaymentType from "entities/transferPaymentType";
import Selectable, { SelectableListViewModel } from "../../../../selectableListViewModel";
import type TransferRefund from "entities/transferRefundResponse";

const navigationName = "foreign";

@Router.registerRoute({
  name: Router.Self,
  route: navigationName,
  children: [ForeignRefundDetailViewModel],
})
@Selectable
export default class ForeignRefundsViewModel extends TransferRefundsViewModel {
  readonly transferRefundType = TransferPaymentType.Foreign;
  readonly refundType = RefundType.ForeignTransfer;

  constructor(
    protected detailViewModelFactory: ReturnType<typeof ForeignRefundDetailViewModel.Factory>,
    protected localizationService: LocalizationService,
    protected eventBus: EventBus,
    protected approvalService: RefundsApprovalService,
    protected optionsService: OptionsService,
    protected repository: RefundRepository,
    protected countrySelectViewModelFactory: ReturnType<typeof CountrySelectViewModel.Factory>
  ) {
    super(
      detailViewModelFactory,
      localizationService,
      eventBus,
      approvalService,
      optionsService,
      repository,
      countrySelectViewModelFactory
    );
    this.navigationName = navigationName;
  }

  @computed
  get self(): SelectableListViewModel<ForeignRefundsViewModel, TransferRefund> {
    return this as any;
  }

  protected processData(items: TransferRefund[]) {
    items.forEach(item => {
      item.isSelectable =
        item.permittedActions.approval.isAllowed && (this.canApprove(item) || false) && this.myApprovalStep(item);

      return item;
    });

    return items;
  }

  onInitialize() {
    this.unsubscriptions.push(this.eventBus.subscribe(foreignTransferRefundUpdated, this.loadData));
    return super.onInitialize();
  }

  @bound
  translate(code: string, size?: number) {
    return this.localizationService.translateModule(Modules.finance, `refundApprovals.foreign.${code}`, size);
  }
}
